import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getPractitionerList,
  toggleShareWithPractitioner,
} from "../../actions/practitionerAction";
import { setActivePractitionerForProfile } from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import Loader from "../../components/Loader";
import { formatDate, getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import AddNewPractitionerPopup from "./AddNewPractitionerPopup";
import { BUCKET_NAME } from "../../constants/states";
const PractitionersList = () => {
  const practitionerList = useSelector(
    (state) => state.practitioner.practitionerList
  );
  const [filteredList, setFilteredList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [localStorageValue, setLocalStorageValue] = useState(getUserDetail());
  useEffect(() => {
    const handleStorageChange = () => {
      setLocalStorageValue(getUserDetail());
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getPractitionerList(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(practitionerList);
  }, [practitionerList]);

  const handleToggleShare = (id, active) => {
    let actionName = active
      ? "patientUnSharesWithPractitioner"
      : "patientSharesWithPractitioner";
    dispatch(
      toggleShareWithPractitioner(actionName, id, () => {
        dispatch(getPractitionerList());
      })
    );
  };

  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = practitionerList.filter((x) => {
      const fullName = `${x.first_name} ${x.last_name}`.toLowerCase();
      const search = searchTerm.toLowerCase();

      return (
        fullName.includes(search) ||
        x.first_name.toLowerCase().includes(search) ||
        x.last_name.toLowerCase().includes(search) ||
        x.clinic_name?.toLowerCase().includes(search) ||
        x.clinic_url?.toLowerCase().includes(search)
      );
    });
    setFilteredList(newList);
  };

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className=" btn-orange  btn-table "
            onClick={() => {
              history.push("/app/prescriptions");
            }}
          >
            View
          </button>
        </div>
      </>
    );
  };

  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/practitioner/info");
          dispatch(setActivePractitionerForProfile(row.Practitioner_ID));
        }}
      >
        <img
          src={
            row.Has_Profile_Picture
              ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                  row.user_id
                }.png?${Math.random()}`
              : Avatar
          }
          alt="icon"
        />{" "}
        <span>View</span>
      </button>
    );
  };

  const columns = [
    {
      dataField: "ID",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "first_name",
      text: "Name",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            {" "}
            <p style={{ marginBottom: 0 }}>
              {row.first_name} {row.last_name}
            </p>
          </>
        );
      },
    },

    {
      dataField: "clinic_name",
      text: "Clinic",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p style={{ marginBottom: 0 }}>{row.clinic_name}</p>
            <p
              style={{ color: "#f79225", cursor: "pointer", marginBottom: 0 }}
              target="_blank"
              onClick={() =>
                window.open(
                  `http://${row.clinic_url.replace(/(^\w+:|^)\/\//, "")}`,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              {row.clinic_url}
            </p>
          </>
        );
      },
    },
    {
      dataField: "added_date",
      text: "Date Added",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.added_date);
      },
    },
    {
      dataField: "sharing",
      text: "Sharing",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <div style={{ marginTop: "-20px" }}>
              <label className="container-check">
                <input
                  type="checkbox"
                  onChange={() => handleToggleShare(row.ID, row.sharing)}
                  defaultChecked={row.sharing}
                />
                <span className="checkmark-check"></span>
              </label>
            </div>
          </>
        );
      },
    },
    {
      dataField: "action",
      text: "Prescriptions",
      formatter: patientAction,
    },
  ];

  return (
    <div>
      {isLoading && <Loader />}
      <h5 className="profile-title">My Practitioners</h5>
      {!localStorageValue?.isPractitionerConnected ? (
        <div className="col-md-12 d-flex justify-content-end">
          <button className="btn-orange" onClick={() => setShowPopup(true)}>
            Add New
          </button>
        </div>
      ) : (
        ""
      )}
      {showPopup && (
        <AddNewPractitionerPopup closePopup={() => setShowPopup(false)} />
      )}
      {practitionerList.length > 0 ? (
        <>
          <div className="row mt-1">
            <div className="col-md-6">
              <div className="form-group search">
                <div>
                  <label htmlFor="search">
                    {" "}
                    Search: (Practitioner name, clinic or website)
                  </label>
                  <div className="input">
                    <input
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={handleChange}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
          </div>
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="ID"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">
          There are no practitioners available at this time
        </p>
      )}
    </div>
  );
};

export default PractitionersList;
